import { useEffect, useState } from 'react';

/**
 * Hook to track page visibility changes
 * Uses the Page Visibility API to detect when user switches tabs or minimizes browser
 */
export const usePageVisibility = () => {
  const [isVisible, setIsVisible] = useState(!document.hidden);
  const [visibilityChanges, setVisibilityChanges] = useState(0);

  useEffect(() => {
    const handleVisibilityChange = () => {
      const visible = !document.hidden;
      setIsVisible(visible);
      setVisibilityChanges(prev => prev + 1);
      
      console.log(`👁️ [PageVisibility] Tab ${visible ? 'visible' : 'hidden'}`);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  return {
    isVisible,
    visibilityChanges
  };
};
